// these constants are for quick test of specific cases

export const MODE_SOCKET_KEEP_ACTIVE: string = 'socket-keep-active';

export const MODE_FAQ_API_ERROR: string = 'faq-api-error';

export const MODE_MESSAGE_API_ERROR: string = 'message-api-error';
export const MODE_MESSAGE_POST_API_ERROR: string = 'message-post-api-error';
export const MODE_MESSAGE_READ_API_ERROR: string = 'message-read-api-error';

export const MODE_ATTACHMENT_API_ERROR: string = 'attachment-api-error';
export const MODE_ATTACHMENT_POST_API_ERROR: string =
  'attachment-post-api-error';

export const MODE_INQUIRY_API_ERROR: string = 'inquiry-api-error';

export const MODE_TARGET_API_ERROR: string = 'target-api-error';

export const MODE_AUTH_API_ERROR: string = 'auth-api-error';

export const MODE_PARTNER_API_ERROR: string = 'partner-api-error';
